import { DiscussionsList } from './DiscussionsList';
import { useDiscussions } from './useDiscussions';
import css from './DiscussionsPage.module.css';
import type { FilterMode } from './types';

const LABELS = {
  loading: 'Загрузка...',
  error: 'Не удалось загрузить обсуждения'
};

const SUMMARY: Record<FilterMode, string> = {
  ownBlog: 'Последние комментарии в вашем дневнике',
  otherBlogs: 'Последние дискуссии с вашим участием', // +  в дневниках других пользователей
  mentions: 'Последние упоминания вас в записях или комментариях'
};

interface Props {
  filterMode: FilterMode;
}

export function DiscussionsPage({ filterMode }: Props) {
  const { discussions, totalRecords, currentPage, pageSize, showPagination, isFetching, isError } =
    useDiscussions(filterMode);

  const summaryText = SUMMARY[filterMode];
  const hasDiscussions = !isFetching && !isError && discussions.length > 0;

  return (
    <>
      <div className={css.content}>
        {hasDiscussions && <div className={css.summary}>{summaryText}</div>}

        {isError && <div className={css.empty}>{LABELS.error}</div>}

        {isFetching && !isError && <div className={css.empty}>{LABELS.loading}</div>}

        {!isFetching && !isError && (
          <DiscussionsList
            discussions={discussions}
            totalRecords={totalRecords}
            currentPage={currentPage}
            pageSize={pageSize}
            showPagination={showPagination}
            filterMode={filterMode}
          />
        )}
      </div>
      <div className={css.bottomSpace} />
    </>
  );
}
